import { useNavigate } from 'react-router-dom-v5-compat'
import { Card, Wrap } from 'shared/components/Base/Base'
import { Box } from 'shared/components/Box/Box'
import { Button } from 'shared/components/Button/Button'
import { TextV2 } from 'shared/components/Text/TextV2'
import { sizes } from 'shared/theme'
import { TYPOGRAPHY } from 'shared/theme/typographyV2'

import { InfoIconLarge } from '../../../components/Icons/Icon'

export const DeadEndDeactivated = () => {
  const navigate = useNavigate()

  return (
    <Wrap maxWidth="632px" align="center">
      <Box mt={10} />
      <Card hasSubtleShadow align="center">
        <img src={InfoIconLarge} width={65} height={65} alt="" />
        <Box mt={2} />
        <TextV2 type={TYPOGRAPHY.header2} className="text-center">
          Your account is not currently active
        </TextV2>
        <TextV2 type={TYPOGRAPHY.paragraph1} className="text-mid-gray mt-4 text-center">
          To reactivate your account, please contact us at{' '}
          <a href="tel:+14692501214" style={{ textDecoration: 'none' }}>
            +1 (469) 250-1214
          </a>
          .
        </TextV2>
        <Box mt={4} />
        <Button size={sizes.extraLarge} variant="primary" onClick={() => navigate(-1)} margin="0 auto">
          Go back
        </Button>
        <Box mt={2} />
      </Card>
      <Box mt={8} />
    </Wrap>
  )
}
